export default "/images/9970449347df6ea055b143244f8e2d4e.avif";